<template>
  <div class="d-flex h-100 flex-column flex-md-row">
    <div id="sidemenu" v-if="state == 'development'">
      <button
        class="sidemenu__btn"
        v-on:click="navOpen = !navOpen"
        v-bind:class="{
          active: navOpen,
          'bg-gray-100': navOpen,
          'bg-white': !navOpen,
        }"
      >
        <span class="top"></span>
        <span class="mid"></span>
        <span class="bottom"></span>
      </button>
      <transition name="translateX">
        <nav v-show="navOpen" class="h-100">
          <div>
            <div class="logo mt-2 mb-4"></div>

            <div class="nav flex-column nav-pills" @click="changeNav()">
              <router-link class="nav-item nav-link" to="./">
                <i class="bi-house"></i>
                <span class="ms-2">Home</span>
              </router-link>
              <router-link class="nav-item nav-link" to="./arrival">
                {{ language.arrival }}
              </router-link>
              <router-link class="nav-item nav-link" to="./inPort">
                {{ language.inPort }}
              </router-link>
              <router-link class="nav-item nav-link" to="./history">
                {{ language.history }}
              </router-link>
              <router-link class="nav-item nav-link" to="./manoeuvreExpected">
                {{ language.manoeuvreExpected }}
              </router-link>
              <router-link class="nav-item nav-link" to="./inManoeuvre">
                {{ language.inManoeuvre }}
              </router-link>
              <router-link class="nav-item nav-link" to="./departure">
                {{ language.departure }}
              </router-link>
              <router-link class="nav-item nav-link" to="./anchored">
                {{ language.anchored }}
              </router-link>
              <router-link class="nav-item nav-link" to="./berthed">
                {{ language.berthed }}
              </router-link>
              <router-link class="nav-item nav-link" to="./hovering">
                {{ language.hovering }}
              </router-link>
            </div>
          </div>
        </nav>
      </transition>
    </div>
    <div class="container-fluid h-100 overflow-auto d-flex flex-column">
      <router-view :key="$route.path" />
    </div>
  </div>
</template>

<style lang="scss">
@import "./assets/app.scss";
</style>
<script>
import store from "./store";
import { computed } from "vue";
export default {
  setup() {
    const language = computed(() => store.getters.getLanguage());
    const state = process.env.NODE_ENV;
    const changeState = (id) => {
      store.mutations.changeLanguage(id);
    };
    return {
      language,
      changeState,
      state,
    };
  },
  data() {
    return {
      navOpen: true,
      window: {
        width: 0,
      },
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.width < 768 ? (this.navOpen = false) : (this.navOpen = true);
    },
    changeNav() {
      if (this.window.width < 768) {
        this.navOpen = !this.navOpen;
      }
    },
  },
};
</script>
